import request from '@/utils/request'

let Maintenance_recordApi = {

  /*维修记录列表*/
  list(data) {
    return request._post('/shop/plus.maintenance_record.Index/index', data);
},
/*添加维修记录*/
add(data) {
    return request._post('/shop/plus.maintenance_record.Index/add', data);
},
/*修改维修记录*/
edit(data) {
    return request._post('/shop/plus.maintenance_record.Index/edit', data);
},
/*删除维修记录*/
del(data) {
    return request._post('/shop/plus.maintenance_record.Index/del', data);
},
/*维修记录详情*/
detail(data) {
  return request._post('/shop/plus.maintenance_record.Index/detail', data);
},
/*评价详情*/
commentDetail(data) {
  return request._post('/shop/plus.maintenance_record.Index/commentDetail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.maintenance_record.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.maintenance_record.Setting/getSetting', data, errorback);
    },
}
export default Maintenance_recordApi;



// WEBPACK FOOTER //
// ./src/api/maintenance_record.js